export default "__VITE_ASSET__BhSB8nGY__"